export function myFunction() {
  // Tabs
  const tabButtons = document.querySelectorAll(".tab-buttons button");
const tabContents = document.querySelectorAll(".tab-content");

if (tabButtons.length && tabContents.length) {
  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tab = btn.getAttribute("data-tab");

      // Remove active class from all
      tabButtons.forEach((b) => b.classList.remove("react-tabs__tab--selected"));
      tabContents.forEach((c) => c.classList.remove("react-tabs__tab--selected"));

      // Add active class
      btn.classList.add("react-tabs__tab--selected");
      const content = document.querySelector(`.tab-content[data-content="${tab}"]`);
      if (content) content.classList.add("react-tabs__tab--selected");
    });
  });
}



  // Carousel
  const track = document.querySelector('.track');
  const viewport = document.querySelector('.viewport');
  const dotsContainer = document.querySelector('.dots');

  if (!track || !viewport || !dotsContainer) return;

  let cards = Array.from(track.querySelectorAll('.card'));
  if (!cards.length) return;

  let activeIndex = 1; // start from the first *real* card
  let autoplayTimer = null;
  const AUTOPLAY_DELAY = 4000;

  // Clone first and last cards for infinite loop
  const firstClone = cards[0].cloneNode(true);
  const lastClone = cards[cards.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, cards[0]);

  // Update cards array
  cards = Array.from(track.querySelectorAll('.card'));

  // Create dots (for real cards only)
  function createDots() {
    dotsContainer.innerHTML = '';
    for (let i = 0; i < cards.length - 2; i++) {
      const btn = document.createElement('button');
      btn.className = 'dot';
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.addEventListener('click', () => {
        activeIndex = i + 1; // shift by 1 because of the prepended clone
        update();
        restartAutoplay();
      });
      dotsContainer.appendChild(btn);
    }
  }

  function getGap() {
    const gapStr =
      getComputedStyle(track).gap ||
      getComputedStyle(track).columnGap ||
      '';
    return parseFloat(gapStr) || 28;
  }

  function update(animate = true) {
    const gap = getGap();
    const cardWidth = cards[0].getBoundingClientRect().width;
    const viewportWidth = viewport.clientWidth;

    // calculate translate
    const translateX =
      activeIndex * (cardWidth + gap) + cardWidth / 2 - viewportWidth / 2;

    // apply transform
    track.style.transition = animate ? 'transform 0.6s ease' : 'none';
    track.style.transform = `translateX(${-translateX}px)`;

    // update dots
    const dots = Array.from(dotsContainer.children);
    dots.forEach((d, i) =>
      d.classList.toggle('active', i === activeIndex - 1)
    );
  }

  function next() {
    activeIndex++;
    update();

    // if we move past the last *real* slide, jump back to first real
    if (activeIndex === cards.length - 1) {
      setTimeout(() => {
        activeIndex = 1; // reset without animation
        update(false);
      }, 600);
    }
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(next, AUTOPLAY_DELAY);
  }
  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }
  function restartAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  // pause autoplay on hover
  viewport.addEventListener('mouseenter', stopAutoplay);
  viewport.addEventListener('mouseleave', startAutoplay);

  // handle resize
  let resizeTimeout = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => update(false), 120);
  });

  // init
  createDots();
  requestAnimationFrame(() => {
    update(false); // no animation first time
    startAutoplay();
  });
  
}